<div class="fit-content-table-container">
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-theme-alpine"
    rowHeight="48"
    rowMultiSelectWithClick="false"
    suppressRowClickSelection="true"
    suppressDragLeaveHidesColumns="true"
    suppressMenuHide="true"
    suppressContextMenu="true"
    enableCellTextSelection="true"
    [icons]="customIcons"
    [columnDefs]="columnDefs()"
    [tooltipShowDelay]="500"
    [defaultColDef]="defaultColDef"
    [paginationPageSize]="paginationPageSize"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    [suppressCellSelection]="true"
    [getMainMenuItems]="getMainMenuItems"
    [suppressScrollOnNewData]="true"
    [rowData]="sharedTestsResultsInfo().testsResults"
    [domLayout]="domLayout"
    (gridReady)="onGridReady($event)"></ag-grid-angular>
</div>

<div class="d-flex justify-content-between align-items-center my-15 has-pagination">
  <div class="pagination-left">
    <app-pagination
      *ngIf="totalRowsCount > paginationPageSize"
      [totalItems]="totalRowsCount"
      [(currentPage)]="currentPageNumber"
      (change)="onPageChange($event)"
      [pageSize]="paginationPageSize"></app-pagination>
  </div>

  <div class="d-flex align-items-center justify-content-end pagination-right">
    <span class="pagination-count"
      >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
    >
    <ul *ngIf="sizes.length" class="pagination">
      <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
        <a tabindex="0" (keyup.enter)="changeSize($event, size)" (click)="changeSize($event, size)">{{ size }}</a>
      </li>
    </ul>
  </div>
</div>
